import fa from "@Platon/external/fa"
import mdi from "@Platon/external/mdi"

export default [...fa, ...mdi]
